import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5606a3b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "check"
}
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "Layer_1",
  x: "0px",
  y: "0px",
  width: "10px",
  height: "10px",
  viewBox: "0 0 10 10",
  style: {"enable-background":"new 0 0 10 10"},
  "xml:space": "preserve"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M4.2,9.3C4,9.3,3.8,9.2,3.7,9.1l-3-3L1.8,5l2.3,2.3l4-6.7l1.3,0.8L4.9,9C4.7,9.2,4.5,9.3,4.2,9.3  L4.2,9.3z",
  fill: "currentColor"
}, null, -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "select-button",
    role: "option",
    tabindex: "0",
    disabled: !!$props.disabled,
    onMousedown: _cache[0] || (_cache[0] = ($event: any) => ($setup.emits('clicked')))
  }, [
    ($props.isLoading)
      ? (_openBlock(), _createBlock($setup["LoadingGif"], {
          key: 0,
          style: {"margin-right":"-4px","transform-origin":"left","transform":"scale(0.6)","margin-top":"-4px","margin-bottom":"-4px"}
        }))
      : _createCommentVNode("v-if", true),
    ($props.isChecked)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", {
      class: _normalizeClass(["text", { disabled: $props.disabled }])
    }, _toDisplayString($props.text), 3 /* TEXT, CLASS */)
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}